import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})
export class PartnerService {

    requestOptions: any;

    constructor(private _http: HttpClient) {
        // this.requestOptions = {
        //     headers: new HttpHeaders({
        //         // 'Authorization': `Bearer ${this.accesstoken}`,
        //         'Content-Type': 'application/json'
        //     })
        // };
    }

    getPartner(accesstoken, url) {
        const headerDict = {
            Authorization: `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        let topBannerResult = this._http
            .get(`${environment.URL}${url}`, requestOptions)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
        return topBannerResult;
    }

    postData(accesstoken, data, url): Observable<any> {
        const headerDict = {
            Authorization: `Bearer ${accesstoken}`,
            // 'Content-Type': 'application/json',
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('thum', data.tmpThumb);
        formData.append('detail1', data.tmpImage1);
        formData.append('description1', data.description1);
        formData.append('detail2', data.tmpImage2);
        formData.append('description2', data.description2);

        let result = this._http.post<any>(`${environment.URL}${url}`, formData, requestOptions);

        return result
    }

    deleteData(accesstoken, id, url) {
        const headerDict = {
            Authorization: `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };
        let result = this._http.delete(`${environment.URL}${url}/${id}`, requestOptions).pipe(map((res: any) => {
            return res;
        }));
        return result;
    }

    updateData(accesstoken, data, url) {
        const headerDict = {
            Authorization: `Bearer ${accesstoken}`,
            // 'Content-Type': 'application/json',
        };
        const requestOptions = {
            headers: new HttpHeaders(headerDict),
        };

        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('thum', data.tmpThumb);
        formData.append('detail1', data.tmpImage1);
        formData.append('description1', data.description1);
        formData.append('detail2', data.tmpImage2);
        formData.append('position', data.position);
        formData.append('status', data.tmpStatus);
        formData.append('description2', data.description2);


        let result = this._http.put(`${environment.URL}${url}/${data.id}`, formData, requestOptions).pipe(map((res: any) => {
            return res;
        }), catchError(error => {
            return throwError(
                Swal.fire({
                    icon: 'error',
                    title: 'board page error !!!',
                    text: 'Try again ?',
                    footer: '<a href="">Contact us</a>'
                })
            );
        }));
        return result;
    }


}
